'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

exports.default = function () {
    var theme = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    theme = Object.assign({}, baseTheme(theme), theme);

    var styleList = _aphroditeJss.StyleSheet.create({
        root: {
            textAlign: 'left',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between',
            color: theme.descriptionColor,
            fontSize: theme.descriptionFontSize,
            lineHeight: theme.descriptionLineHeight,
            width: theme.width,
            minWidth: theme.minWidth,

            '&>*': {
                display: 'flex',
                alignItems: 'center'
            },

            '& .title': {
                fontWeight: theme.twSemi,
                color: theme.color,
                fontSize: theme.fontSize,
                lineHeight: theme.lineHeight
            },

            '& .icon': {
                display: 'block',
                marginRight: theme.gutter * 4 + 'px',
                flexShrink: 0
            }
        }
    });

    return {
        root: (0, _aphroditeJss.css)(styleList.root)
    };
};

var _aphroditeJss = require('aphrodite-jss');

var baseTheme = function baseTheme(theme) {
    return {
        color: theme.tFilled,
        fontSize: theme.tsLarge,
        lineHeight: theme.tlLarge,

        descriptionColor: theme.tInactive,
        descriptionFontSize: theme.tsSmall,
        descriptionLineHeight: theme.tlSmall,
        width: 'auto',
        minWidth: 'auto'
    };
};